import { cx } from "@emotion/css";
import { Link } from "react-router-dom";

interface TextWithLinkProps {
	className?: string;
	questionText?: string;
	linkText: string;
	link?: string;
	pathname?: string;
}

export const TextWithLink = ({
	className,
	questionText,
	linkText,
	link,
	pathname,
}: TextWithLinkProps) => {
	return (
		<div className={cx("size-16", className)}>
			{questionText && <span className="text-grey">{`${questionText} `}</span>}
			<Link
				className="forgot-password"
				to={link ? link : { pathname }}
				target={link ? "_self" : "_blank"}
			>
				{linkText}
			</Link>
		</div>
	);
};
